import {
  CarInsuranceChargeInfo,
  CarInsuranceInfo,
} from "../types/CarInsuranceChargeTypes";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import "./InsuranceModal.scss";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { useCommonUtil } from "../util/useCommonUtil";
import React from "react";
interface InsurancProps {
  detail: CarInsuranceChargeInfo | undefined;
  title?: string;
  onClose: () => void;
}

const InsuranceModal: React.FC<InsurancProps> = ({ detail, onClose }) => {
  const { formatNumber } = useCommonUtil();

  const addLineBreaks = (text: string) => {
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  };
  return (
    <>
      <div className="ins-overlay">
        <div className="ins-container">
          <div className="ins-header">
            <div
              style={{
                width: "100%",
                fontWeight: "700",
                fontSize: "2em",
                textAlign: "center",
                borderBottom: "2px solid #e4e7ec",
                lineHeight: 2.5,
              }}
            >
              보험 상세
            </div>
            <SvgIcon
              component={CloseOutlinedIcon}
              style={{
                position: "absolute",
                fontSize: "3em",
                right: "3%",
                top: "30px",
              }}
              onClick={onClose}
            ></SvgIcon>
          </div>

          <div className="ins-background-wrap">
            <div style={{ maxHeight: "65%", overflow: "auto" }}>
              <div className="ins-background">
                <div className="detail">
                  <div className="ins-name">
                    <span className="name">
                      {detail?.carInsuranceInfo.insuranceName}
                    </span>
                    <span className="etc">
                      {detail?.carInsuranceInfo.insuranceTypeString} / 만{" "}
                      {detail?.carInsuranceInfo.minAge}세 이상 / 운전경력
                      {detail?.carInsuranceInfo.minCareer}년 이상
                    </span>
                  </div>

                  <div className="ins-detail">
                    <div className="ins-detail-wrap">
                      <span className="title">자기부담금</span>
                      <span className="content">
                        {formatNumber(
                          detail?.carInsuranceInfo.chargeImmunity || 0
                        )}
                        <span style={{ marginLeft: "5px" }}>만원</span>
                      </span>
                    </div>

                    <div className="ins-detail-wrap">
                      <span className="title">보상한도</span>
                      <span className="content">
                        {formatNumber(detail?.carInsuranceInfo.limitPrice || 0)}
                        <span style={{ marginLeft: "5px" }}>만원</span>
                      </span>
                    </div>
                    <div className="ins-detail-wrap">
                      <span className="title">부담내용</span>
                      <span className="content">
                        {detail?.carInsuranceInfo.contentRole && addLineBreaks(detail?.carInsuranceInfo.contentRole as string)}
                      </span>
                    </div>

                    <div className="ins-detail-wrap">
                      <span className="title">규정내용</span>
                      <span className="content">
                        {detail?.carInsuranceInfo.contentBurden && addLineBreaks(detail?.carInsuranceInfo.contentBurden as string)}
                      </span>
                    </div>

                    <div className="ins-detail-wrap">
                      <span className="title">기타내용</span>
                      <span className="content">{detail?.carInsuranceInfo.content && addLineBreaks(detail?.carInsuranceInfo.content as string)}</span>
                    </div>

                    <div style={{ display: "flex", marginBottom: "10px" }}>
                      <span className="title">가격</span>
                      <span className="content">
                        {formatNumber(detail?.chargeRequester || 0)}원
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div
              className="arrow-wrap"
              style={{
                position: "relative",
                zIndex: "9999",
                borderBottom: "0",
              }}
            >
              <SvgIcon
                component={KeyboardArrowUpOutlinedIcon}
                style={{
                  fontSize: "8em",
                  marginRight: "30px",
                  color: "#e4e7ec",
                }}
              ></SvgIcon>
              <SvgIcon
                component={KeyboardArrowDownOutlinedIcon}
                style={{ fontSize: "8em", color: "#3E83F1" }}
              ></SvgIcon>
            </div> */}
          </div>
          <div style={{ padding: "15px" }}>
            <div className="help-wrap">
              <div
                style={{
                  display: "flex",
                  marginBottom: "30px",
                  alignItems: "center",
                }}
              >
                <SvgIcon
                  component={ErrorOutlineOutlinedIcon}
                  style={{
                    fontSize: "1.2em",
                    marginRight: "10px",
                    color: "#5c6373",
                  }}
                ></SvgIcon>
                <span className="title">자기부담금</span>
                <span className="content">
                  사고 발생시 운전자가 부담해야 하는 수리 비용
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  marginBottom: "30px",
                  alignItems: "center",
                }}
              >
                <SvgIcon
                  component={ErrorOutlineOutlinedIcon}
                  style={{
                    fontSize: "1.2em",
                    marginRight: "10px",
                    color: "#5c6373",
                  }}
                ></SvgIcon>
                <span className="title">보상한도</span>
                <span className="content">
                  보험으로 처리 가능한 사고비용의 최대 한도
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  marginBottom: "30px",
                  alignItems: "center",
                }}
              >
                <SvgIcon
                  component={ErrorOutlineOutlinedIcon}
                  style={{
                    fontSize: "1.2em",
                    marginRight: "10px",
                    color: "#5c6373",
                  }}
                ></SvgIcon>
                <span className="title">단독사고</span>
                <span className="content">
                  다른 차량이나 사람과의 추돌 또는 충돌 사고가 아닌, 차량
                  단독으로 주·정차된 차량 및 시설물을 접촉하거나 본인과실 100%
                  사고인 경우
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InsuranceModal;
